// src/lib/api.js
import axios from "axios";
import { readTenantId } from "../tenant/tenantStorage";

export const api = axios.create({
    baseURL: "https://api.educacaoalternativa360.com.br",
    withCredentials: true,
});
api.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

// === Header x-tenant-id ===
api.interceptors.request.use((config) => {
    try {
        const tid = readTenantId();
        if (tid) {
            config.headers = config.headers || {};
            // use o mesmo nome que o backend lê (x-tenant-id ou x-tenant)
            config.headers["x-tenant-id"] = tid;
        }
    } catch { }
    return config;
}, (err) => Promise.reject(err));

/* ====== (opcionais) seus loggers e auth interceptors existentes ====== */
let LOGGER_ATTACHED = false;
export function attachAxiosLoggerOnce() {
    if (LOGGER_ATTACHED) return;
    LOGGER_ATTACHED = true;

    api.interceptors.response.use(
        (res) => {
            try {
                const method = res.config.method?.toUpperCase();
                const url = res.config.url;
                const reqParams = res.config.params;
                const reqData = safeJson(res.config.data);
                const resData = safeJson(res.data);

                console.log(`[HTTP ${res.status}] ${method} ${url}`, { reqParams, reqData, resData });
            } catch { }
            return res;
        },
        (err) => {
            try {
                const cfg = err?.config || {};
                const status = err?.response?.status;
                const method = cfg.method?.toUpperCase();
                const url = cfg.url;
                const reqParams = cfg.params;
                const reqData = safeJson(cfg.data);
                const resData = safeJson(err?.response?.data);

                console.warn(`[HTTP ${status ?? "ERR"}] ${method} ${url}`, { reqParams, reqData, resData, msg: err?.message });
            } catch { }
            return Promise.reject(err);
        }
    );
}

function safeJson(v) {
    try {
        if (typeof v === "string") {
            try { return JSON.parse(v); } catch { return v; }
        }
        return v;
    } catch { return "<unserializable>"; }
}

let AUTH_REDIRECTING = false;
function clearLocalAuthArtifacts() {
    try {
        localStorage.clear();
        sessionStorage.clear();
        const dbs = ["firebase-heartbeat-database", "firebase-installations-database"];
        if ("indexedDB" in window) {
            dbs.forEach((dbName) => {
                const req = indexedDB.deleteDatabase(dbName);
                req.onerror = () => { };
                req.onsuccess = () => { };
            });
        }
    } catch { }
}

function goToLogin() {
    if (AUTH_REDIRECTING) return;
    AUTH_REDIRECTING = true;
    const from = encodeURIComponent(window.location.pathname + window.location.search);
    window.location.assign(`/?from=${from}`);
}

export function attachAuthInterceptorOnce() {
    if (api.__AUTH_ATTACHED__) return;
    api.__AUTH_ATTACHED__ = true;

    api.interceptors.response.use(
        (res) => res,
        async (error) => {
            const status = error?.response?.status;
            if ([401, 403, 419, 440].includes(status)) {
                try { await api.post("/api/auth/logout").catch(() => { }); } catch { }
                clearLocalAuthArtifacts();
                goToLogin();
                return Promise.reject(error);
            }
            return Promise.reject(error);
        }
    );
}
